export default "__VITE_ASSET__CMq7dnMd__"